<span [class]="blockClass" *ngFor="let block of blocks" [ngStyle]="blockStyle" aria-hidden="true"></span>
